// removed by extract-text-webpack-plugin
module.exports = {"activities":"_2Qp8575kti02OgwfZGm1cy","header":"uLlRQdQJWUlm7bZ5Q_Cth","title":"_2AoB0dA1Ov1aL5SDZF_UtS","activityTotal":"EopWta03gbocMASWpdcU0","activitySort":"_1MHX6V-NRHRfQSoRpj0oxQ","activityList":"_1DO26td29j-OBVWdsAWh4a","activityItem":"_3hBtrFuFUP-p18kUUHaCC0","thumbnail":"_4Ov0O8ssBeQLeFifJ7GJJ","content":"_2iMmVTP_70--exk-R7J7-1","contentText":"_98x2vBVAFZOORFUc3Y5Pu","date":"_2jLrsqjWPVR3ZrDXAIWyJq","iconCalendar":"CeUcSbwjySstbGsSIgb7G","dateContent":"FPpRICugIhUZfCOwn26z4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountManagement/Activities.scss
// module id = 1079
// module chunks = 0